<div *ngIf="show">
  <div class="spinner-overlay" style="z-index: 15000;">
    <div class="spinner-border text-primary" role="status"></div>
    <div class="spinner-body">
      <h2 class="spinner-message">{{message | async | translate}}</h2>
    </div>
  </div>

  <div class="spinner-overlay-backdrop show" style="z-index: 10000;"></div>
</div>